export class User {
  emailAddress?: string | null;
  password?: string | null;
  _id?: string | null;
  roles?: string[];
  authToken?: string | null;
  authTokenExpiresAt?: string | null;
  lastName?: string;
  firstName?: string;
}
